<div class="or-p-16-px or-pt-40-px or-bg-shade">
  <div class="or-head-xs or-color-secondary-2 or-mb-12-px">Moderacja użytkownika</div>

  <div class="or-head-sm or-truncate-at-line-1 or-mb-20-px">{{ user.name }} {{ user.lastName }}</div>

  @for (action of actions(); track action.flag) {
    <div
      (click)="select(action)"
      class="border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px"
      [class.or-cursor-pointer]="!action.disabled"
      [class.moderation-action--disabled]="action.disabled">
      <or-icon [name]="action.icon" size="s" boxed class="or-mr-8-px" />
      <div class="or-text-md">{{ action.label }}</div>
    </div>
  }
</div>
